// extracted by mini-css-extract-plugin
export default {"root":"j2kbD","stat":"_2mFCC","label":"_3se9l"};